import React from 'react';

interface QuestionEditModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    children: React.ReactNode;
    confirmText?: string;
    confirmButtonClass?: string;
}

const QuestionEditModal: React.FC<QuestionEditModalProps> = ({ 
    isOpen, 
    onConfirm, 
    onCancel, 
    title, 
    children, 
    confirmText = 'Salvar',
    confirmButtonClass = 'bg-blue-600 hover:bg-blue-700' 
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 z-50 flex justify-center items-center p-4"
            aria-modal="true"
            role="dialog"
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onCancel();
                }
            }}
        >
            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col animate-fade-in">
                <div className="px-6 py-4 border-b border-gray-200 dark:border-slate-700">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h2>
                </div>
                <div className="flex-1 overflow-y-auto px-6 py-4">
                    {children}
                </div>
                <div className="px-6 py-4 border-t border-gray-200 dark:border-slate-700 flex justify-end gap-4 bg-white dark:bg-slate-800">
                    <button
                        onClick={onCancel}
                        className="bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-slate-600 dark:hover:bg-slate-500 dark:text-white font-bold py-2 px-6 rounded-lg transition-colors"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`${confirmButtonClass} text-white font-bold py-2 px-6 rounded-lg transition-colors`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QuestionEditModal;

